window.addEventListener('scroll', {className: '.scroll_up', margin: 100, handleEvent: addClassToTextAndImagesForAnimation});

function addClassToTextAndImagesForAnimation(e) {
    const targetElm = document.querySelectorAll(this.className);
    for (let i = 0; i < targetElm.length; i++) {
        if (window.innerHeight > targetElm[i].getBoundingClientRect().top + this.margin) {
            targetElm[i].classList.add('on');
        }
    }
}